module.exports = __webpack_public_path__ + "static/media/the-empire-strikes-back-thumb.72f43033.png";